import { RootState } from 'App';

export const categoriesSelector = ({ categories }: RootState) => categories;
